import { IonContent } from '@ionic/react';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { amplitudeModule } from '@/modules/amplitude';
import { OnboardingFooter } from '@/pages/Onboarding/components/Footer';
import {
  OnboardingOptionItem,
  OnboardingOptionsList,
} from '@/pages/Onboarding/components/List';
import { OnboardingNavigation } from '@/pages/Onboarding/components/Navigation';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingSubtitle } from '@/pages/Onboarding/components/Subtitle';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnboardingParamsTool } from '@/pages/Onboarding/utils/paramsTool';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';
import { preloadImage } from '@/utils/preloadImage';

import { LayoutDataType } from '../../types';

import { TOPICS_OPTIONS } from './constants';

export const ScreenTopics: React.FC = () => {
  React.useEffect(() => {
    if (canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Topics',
      });
    }

    preloadImage(
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png',
    );
  }, []);

  const { wizard } = useOnboarding();

  const form = useFormContext<LayoutDataType>();
  const topics = form.watch('topics');

  const handleNextStep = (): void => {
    const selectedTopicOption = TOPICS_OPTIONS.find(
      (option) => option.id === topics,
    );
    userService.createOrUpdate({
      onboarding_data: {
        topics: selectedTopicOption?.title || '',
      },
    });
    wizard.nextStep();
    OnboardingParamsTool.setParam('step', 'appusers');
  };

  return (
    <OnboardingPage>
      <OnboardingNavigation />

      <IonContent className="onboarding-topics">
        <OnboardingTitle>
          What are you mostly looking for in Dialogue?
        </OnboardingTitle>
        <OnboardingSubtitle>
          Our aim is to personalize your experience
        </OnboardingSubtitle>
        <OnboardingOptionsList>
          {TOPICS_OPTIONS.map((option) => (
            <OnboardingOptionItem
              checked={topics === option.id}
              control={form.control}
              option={option}
              name="topics"
              key={option.id}
              onChange={(value) => {
                OnboardingParamsTool.setParam('topics', value);
              }}
            />
          ))}
        </OnboardingOptionsList>
      </IonContent>

      <OnboardingFooter onContinue={handleNextStep} disabled={!topics} />
    </OnboardingPage>
  );
};
